import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useReviewOrderStyles = makeStyles({
    root: {},
    titleContainerTitle: {
        height: '100%',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    baseInfoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: '.5fr 1fr 1fr .1fr',
        rowGap: tokens.spacingVerticalL
    },
    shippingSection: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalL
    },
    titleContainer: { ...shorthands.gridArea('1', '1', '1', '2') },
    baseInfoContainer: { ...shorthands.gridArea('2', '1', '2', '1') },
    serviceAddressContainer: { ...shorthands.gridArea('2', '2', '2', '2') },
    billingAddressContainer: { ...shorthands.gridArea('3', '1', '3', '1') },
    baseInfoEditContainer: { ...shorthands.gridArea('4', '1', '4', '2') },
    link: {
        color: tokens.colorBrandForegroundLink
    },
    orderSection: {
        marginBottom: tokens.spacingVerticalM,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    }
});
